angular.module('services')
.factory('apiSrv', ['$q', '$http', '$interval', 'apiConfig', 'URL_PREFIX', 'USE_MOCKS',
		function($q, $http, $interval, apiConfig, URL_PREFIX, USE_MOCKS) {
	var SPINNER_INTERVAL = 100,
		scope = this,
		cancelInterval,
		service = function(apiName, config) {
			config = config || {};

			if (config.method === 'POST' && (apiConfig.useMocks || USE_MOCKS)) {
				console.log('=========== Start POST request =========');
				console.log('url:' + config.url);
				console.log('params:' + config.params);
				console.log('data:' + angular.toJson(config.data));
				console.log('============ End POST request ==========')
			}

			if ((apiConfig.useMocks || USE_MOCKS) && apiConfig.mocks) {
				if(apiConfig.mocks[apiName].url.indexOf("mocks") > -1)
					config.url = URL_PREFIX + '/' + apiConfig.mocks[apiName].url;
				else
					config.url = "http://localhost:3007/" + apiConfig.mocks[apiName].url;
				config.method = 'GET';
			}
			else if (apiConfig.api && apiConfig.api[apiName]) {
				config.url = URL_PREFIX + '/' + apiConfig.api[apiName].url;
			}
			else {
				console.log("The api '" + apiName + "' is not found!");
				config.url='default.json';
			}

			if (scope.$emit) {
				scope.spinner = 1;
				scope.$emit('spinner:start');
				cancelInterval = $interval(function() {
					scope.$emit('spinner:update');
					scope.spinner++;
				}, SPINNER_INTERVAL);
				scope.$on('$destroy', $interval.cancel(cancelInterval));
			}

			return $http(config).then(function(response) {
				$interval.cancel(cancelInterval);
				scope.spinner = 0;
				scope.$emit && scope.$emit('spinner:stop');
				return response.data;
			}, function(reason) {
				scope.spinner = 0;
				scope.$emit && scope.$emit('error', reason);
				$q.reject(reason);
			});
		};

	return service;
}]);
